import React, { useState, useContext, useEffect } from 'react';
import { TakeoverLayout } from '_lex/_layouts/TakeoverLayout';
import { Stack } from '@mui/material';
import { QuickSearch } from 'components/_atoms';
import { translate as t } from 'hooks/useTranslations';
import { GridRowSelectionModel } from '@mui/x-data-grid-pro';
import Loading from 'views/App/Portal/Loading';
import useDTBPackage from '../../Packages/_data_source/useDTBPackage';
import { AppContext } from 'views/App/context';
import { useParams } from 'react-router-dom';
import AssignmentHistoryList from './components/AssignmentHistoryList';

const AssignmentHistory: React.FC = () => {
  const { currentOrganizationId } = useContext(AppContext);
  const { id } = useParams<{ id: string }>();
  const [assignedToGroups, setAssignedToGroups] = useState<any[]>([]);
  const [groupSearchTerm, setGroupSearchTerm] = useState<string>('');
  const [rowSelectionModel, setRowSelectionModel] = useState<GridRowSelectionModel>([]);

  const dtbPackageQuery = useDTBPackage(currentOrganizationId || '', id || '');

  useEffect(() => {
    if (dtbPackageQuery.data && !dtbPackageQuery.isError) {
      setAssignedToGroups(dtbPackageQuery.data.assignedToGroups || []);
    }
  }, [dtbPackageQuery.data, dtbPackageQuery.isError]);

  useEffect(() => {
    if (dtbPackageQuery.data && !dtbPackageQuery.isError) {
      const assignedGroups = dtbPackageQuery.data.assignedToGroups || [];
      if (groupSearchTerm.length > 0) {
        setAssignedToGroups(assignedGroups.filter((group: any) => group.name.includes(groupSearchTerm)));
      } else {
        setAssignedToGroups(assignedGroups);
      }
    }
  }, [groupSearchTerm, dtbPackageQuery.data, dtbPackageQuery.isError]);

  if (dtbPackageQuery.isFetching) {
    return <Loading />;
  }

  return (
    <TakeoverLayout
      pageTitle={`${dtbPackageQuery.data?.name || 'Assignment History'} - Assignment`}
      backUrl='/admin/dtbs/assignments'
      headerProps={{
        title: t('dtbs.assignments.history.title', 'Assignment History'),
        subtitle: t('dtbs.assignments.history.subtitle', 'View group assignment history for DTB packages'),
      }}
      pageToolbarLeft={
        <QuickSearch
          id='organization_search'
          initialValue={groupSearchTerm}
          onChange={(val) => setGroupSearchTerm(val)}
          placeholder={t('dtbs.assignments.history.search', 'Search groups')}
        />
      }
    >
      <Stack spacing={2}>
        <AssignmentHistoryList
          assignedToGroups={assignedToGroups}
          rowSelectionModel={rowSelectionModel}
          setRowSelectionModel={setRowSelectionModel}
          groupSearchTerm={groupSearchTerm}
        />
      </Stack>
    </TakeoverLayout>
  );
};

export default AssignmentHistory;
